/* istanbul ignore file */

import { AuthProtectedComponent } from '@statsbomb/kitbag-auth';
import { VideoKeyBoardShortcutProvider, _useVideoProvider as useVideoProvider } from '@statsbomb/video-client-js';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import env from '@/env';

export const VideoProvider = ({ children }: { children: ReactNode }) => {
  const { i18n } = useTranslation('videoClient');

  useVideoProvider({
    baseUrlVideoService: env.VITE_VIDEO_SERVICE_URL,
    streamsOnly: true,
    translations: i18n.getResourceBundle(i18n.language, 'videoClient'),
  });

  return children;
};

export const VideoAuthAndKeyboardWrapper = ({ children }: { children: ReactNode }) => (
  <AuthProtectedComponent>
    <VideoKeyBoardShortcutProvider>{children}</VideoKeyBoardShortcutProvider>
  </AuthProtectedComponent>
);
